module.exports = __webpack_public_path__ + "img/3.571bb501.jpg";